// extracted by mini-css-extract-plugin
export default {"wrapper":"SU-z"};